/**
 * Namespace for myWAC specific Objects, Methods and data for client-side use
 * @namespace EBContext
 * @author Luk� Sembol <lukas.sembol@mywac.cz>
 */
var EBContext = EBContext || {};

/**
 * Namespace for various downloadable cached objects
 * @namespace EBContext.data
 */
EBContext.data = EBContext.data || {};

/**
 * Namespace for standardized EBContext plugins
 * @namespace EBContext.modules
 */
EBContext.modules = EBContext.modules || {};

/**
 * Namespace for standardized actions to be called from CMSMenu
 * @namespace EBContext.actions
 */
EBContext.actions = EBContext.actions || {};

/**
 * Object for storing (and referencing) instances of EBContext modules
 * @type {Object}
 * @name instances
 * @memberof EBContext
 */
EBContext.instances = EBContext.instances || {};

/**
 * Object for storing block-specific data and instances of EBContext modules
 * @name pages
 * @memberof EBContext
 * @type {Object}
 */
EBContext.pages = EBContext.pages || {};

/**
 * Namespace for default template and debug settings
 * @namespace EBContext.options
 */
EBContext.options = EBContext.options || {};

/**
 * Namespace for various IDs and configuration
 * @namespace EBContext.config
 */
EBContext.config = EBContext.config || {};

/**
 * Object with styles for themed console output.
 * This is used to distinguish caught MW exceptions from general JS errors
 * @name EBContext.options.consoleStyles
 * @type {Object}
 */
EBContext.options.consoleStyles = {
	errorMsg: 'color: #333; background-color: pink; padding: 3px',
	warnMsg: 'color: #333; background-color: yellow; padding: 3px',
	infoMsg: 'color: #333; background-color: lightskyblue; padding: 3px',
	errorBtn: 'color: #333; font-weight: bold; display: block; background-color: pink; border: 1px solid red; border-radius: 5px; padding: 5px 15px',
	warnBtn: 'color: #333; font-weight: bold; display: block; background-color: yellow; border: 1px solid orange; border-radius: 5px; padding: 5px 15px',
	infoBtn: 'color: #333; font-weight: bold; display: block; background-color: lightskyblue; border: 1px solid blue; border-radius: 5px; padding: 5px 15px',
	code: 'font-family: Courier-new, Courier, monospace'
};

/**
 * Namespace for standalone helper functions
 * @namespace utils
 * @memberof EBContext
 */
EBContext.utils = EBContext.utils || {};

/**
 * Function to case-insensitive search for resource texts
 * @param id Resource ID
 * @returns If resource with given ID (case insensitive) exists in current language, returns its text, else returns uppercase ID
 */
EBContext.resource = function (id) {
	id = id.toString().toUpperCase();
	return (EBContext && EBContext.data && EBContext.data.resources && EBContext.data.resources.hasOwnProperty(id) ? EBContext.data.resources[id] : id);
};

EBContext.resourceInflection = function(t, n) {
	switch(t.toLowerCase()){
		case 'dny':
			if(n===1) return n + ' ' + EBContext.resource('DEN');
			if(n>0 && n<5) return n + ' ' + EBContext.resource('DNY');
			return n + ' ' + EBContext.resource('DNI');
	}
};

/**
 * helper namespace for EBContext, that shortens path to most used namespaces and functions
 * @namespace ebc
 * *** - Dokud tady bude tento ��dek, tak nikdy nepou��vat v k�du, jen k lad�n� v konzoli! Struktura objektu se je�t� m��e zm�nit!
 */
var ebc = {
	d: EBContext.data,
	m: EBContext.modules,
	p: EBContext.pages,
	o: EBContext.options,
	r: EBContext.resource,
	u: EBContext.utils
};

/**
 * Merges two or more JS objects
 * @param {boolean} [mode] If specified, deep merge is used; if true then Arrays are merged (without duplicates), else Arrays are replaced
 * @param {...Object} obj Two or more JS plain objects to merge. First Object is target into which consequential objects are merged
 * @returns {Object} New Object with deep clones of all source objects sequentially merged into it 
 * @example <caption>Basic usage example</caption>
 * obj1 = {'A': 5, 'B': 'Excelsior', 'C': true};
 * obj2 = {'A': 6, 'B': {'B1': 1, 'B2': 2}, 'D': [1, 2, 3, 5]};
 * var a = EBContext.utils.extendObj(obj1, obj2);
 * // a = {'A': 6, 'B': {'B1': 1, 'B2': 2}, 'C': true, 'D': [1, 2, 3, 5]};
 * @example <caption>Example with deep merge</caption>
 * obj1 = {'A': 5, 'B': 'Excelsior', 'C': true};
 * obj2 = {'A': 6, 'B': {'B1': 1, 'B2': 2}, 'D': [1, 2, 3, 5]};
 * obj3 = {'A': 8, 'B': {'B1': 5, 'B3': 'A'}, 'D': [6, 7, 8, 3, 4]};
 * var a = EBContext.utils.extendObj(true, obj1, obj2, obj3);
 * // a = {'A': 8, 'B': {'B1': 5, 'B2': 2, 'B3': 'A'}, 'C': true, 'D': [1, 2, 3, 5, 6, 7, 8, 4]};
 * @example <caption>Example with deep merge of Object but not Arrays</caption>
 * obj1 = {'A': 5, 'B': 'Excelsior', 'C': true};
 * obj2 = {'A': 6, 'B': {'B1': 1, 'B2': 2}, 'D': [1, 2, 3, 5]};
 * obj3 = {'A': 8, 'B': {'B1': 5, 'B3': 'A'}, 'D': [6, 7, 8, 3, 4]};
 * var a = EBContext.utils.extendObj(false, obj1, obj2, obj3);
 * // a = {'A': 8, 'B': {'B1': 5, 'B2': 2, 'B3': 'A'}, 'C': true, 'D': [6, 7, 8, 3, 4]};
 */
EBContext.utils.mergeObj = function () {
	var bRecursive = false;
	var bMergeArrays = false;
	var targetObj = {};
	var i = 0;
	var extender = null;

	/**
	 * @param {Object} obj1 Target plain JS Object to merge second one into.
	 * @param {Object} obj2 A plain JS Object to merge into first one.
	 * @returns {Object} Returns JS Object 'obj1' with 'obj2' merged into it.
	 */
	var mergeObj = function (obj1, obj2) {
		for (var key in obj2) {
			if (Array.isArray(obj1[key]) && Array.isArray(obj2[key]) && bMergeArrays) {
				obj1[key] = EBContext.utils.array.merge(obj1[key], obj2[key]);
			} else if (EBContext.utils.isPlainObj(obj1[key]) && EBContext.utils.isPlainObj(obj2[key]) && bRecursive) {
				obj1[key] = mergeObj(obj1[key], obj2[key]);
			} else {
				obj1[key] = obj2[key];
			}
		}
		return obj1;
	};

	if (arguments.length > 2 && typeof arguments[0] === 'boolean') {
		bRecursive = true;
		bMergeArrays = arguments[0];
		i = 1;
	}
	for (i; i < arguments.length; i++) {
		if (i === arguments.length - 1 && arguments[i] === undefined) continue;
		extender = EBContext.utils.getObj(arguments[i]);
		if (!extender) {
			continue;
		}
		targetObj = mergeObj(targetObj, EBContext.utils.cloneObj(extender));
	}
	return targetObj;
};

/**
 * Extends first passed object with all subsequentials
 * @param {boolean} [mode] If specified, deep merge is used; if true then Arrays are merged (without duplicates), else Arrays are replaced
 * @param {...Object} obj Two or more JS plain objects to merge. First Object is target into which consequential objects are merged
 * @returns {Object} Reference to the first object with all other objects sequentially merged into it 
 */
EBContext.utils.extendObj = function () {
	var bRecursive = false;
	var bMergeArrays = false;
	var i = 0;
	var extender = null;

	/**
	 * @param {Object} obj1 Target plain JS Object to merge second one into.
	 * @param {Object} obj2 A plain JS Object to merge into first one.
	 * @returns {Object} Returns JS Object 'obj1' with 'obj2' merged into it.
	 */
	var mergeObj = function (obj1, obj2) {
		for (var key in obj2) {
			if (Array.isArray(obj1[key]) && Array.isArray(obj2[key]) && bMergeArrays) {
				obj1[key] = EBContext.utils.array.merge(obj1[key], obj2[key]);
			} else if (EBContext.utils.isPlainObj(obj1[key]) && EBContext.utils.isPlainObj(obj2[key]) && bRecursive) {
				obj1[key] = mergeObj(obj1[key], obj2[key]);
			} else {
				obj1[key] = obj2[key];
			}
		}
		return obj1;
	};

	if (arguments.length > 2 && typeof arguments[0] === 'boolean') {
		bRecursive = true;
		bMergeArrays = arguments[0];
		i = 1;
	}
	var targetObj = EBContext.utils.getObj(arguments[i]);
	for (i; i < arguments.length; i++) {
		if (i === arguments.length - 1 && arguments[i] === undefined) continue;
		extender = EBContext.utils.getObj(arguments[i]);
		if (!extender) {
			continue;
		}
		targetObj = mergeObj(targetObj, EBContext.utils.cloneObj(extender));
	}

	return targetObj;
};

/**
 * HelperFunction to simplify finding an Object in global scope
 * @param {String|Array.<String>|Object} reference Object itself or path to it in scope
 * @param {Object} [scope=window] Scope of search
 * @returns {Object|null} Returns object if found, else returns reference
 */
EBContext.utils.getObj = function (reference, scope) {
	scope = scope || window;
	if(Array.isArray(reference) || typeof reference === 'string') return EBContext.utils.searchObj(scope, reference);
	return reference;
};

/**
 * Soft accessor to EBContext properties
 * @param {Array.<string>|string} path Path to target object within EBContext - nesting with dot notation
 * @param {function} [callback] Callback function to be called in a context of found object (if found)
 * @returns {*} If nothing is found in given path, returns `null` else returns callback return value
 */
EBContext.utils.callObj = function (path, callback) {
	var target = EBContext.utils.searchObj(EBContext, path);
	if (target && callback && typeof callback === 'function') {
		return (callback).bind(target)();
	}
	return null;
};

/**
 * @param {Object} obj Source plain JS Object to clone.
 * @returns {Object} Returns new JS Object with 'obj' deep-cloned.
 */
EBContext.utils.cloneObj = function (obj) {
	var retObj = {};
	for (var key in obj) {
		if (EBContext.utils.isPlainObj(obj[key])) {
			retObj[key] = EBContext.utils.cloneObj(obj[key]);
		} else {
			retObj[key] = obj[key];
		}
	}
	return retObj;
};

/**
 * @param {*} obj Any variable to test whether it is a plain JS Object or not.
 * @returns {boolean} Returns true if passed variable is a plain JS Object, otherwise returns false.
 */
EBContext.utils.isPlainObj = function (obj) {
	return (obj && typeof obj === 'object' && obj.constructor === Object);
};

/**
 * This function unifies parsing of object path to keys array
 * @param {Array.<string>|string} path Path to target object within EBContext - nesting with dot notation
 * @returns {Array.<string>|null} 'null' if path is unparsable, else array of keys (string)
 */
EBContext.utils.getPathArr = function (path) {
	if (Array.isArray(path)) {
		return path;
	} else if (typeof path === 'string') {
		return path.split('.');
	}
	console.error('%c@Invalid path!', EBContext.options.consoleStyles.errorMsg);
	return null;
};

/**
 * This function access path of nested objects
 * @param {Object} scope Reference to an object representing search scope
 * @param {Array.<String>|String} path Parameter 'path' is supposed to be array of keys of nested objects representing the path to access
 * @param {Boolean} [create] Force creation of objects in path which doesn't exist already (overrides all values with given keys with empty objects to ensure accessibility of given path)
 * @returns {*} 'null' if path not found or content of the path
 */
EBContext.utils.searchObj = function (scope, path, create) {
	if (create) return EBContext.utils.setObj(scope, path);
	if(!path) return null;
	var pathArr = EBContext.utils.getPathArr(path);
	if (!pathArr) return null;
	var i;
	for (i = 0; i < pathArr.length; i++) {
		if (!scope || !scope.hasOwnProperty(pathArr[i])) {
			return null;
		}
		scope = scope[pathArr[i]];
	}
	return scope;
};

/**
 * @param {Object} scope Reference to an object representing search scope
 * @param {Array.<string>|string} path Path to target object within EBContext - nesting with dot notation
 * @param {*} [value] Value to be set to the last key in path
 * @returns {*} Returns reference to last object in specified path
 */
EBContext.utils.setObj = function (scope, path, value) {
	if(!path) return null;
	let pathArr = EBContext.utils.getPathArr(path);
	if (!pathArr) return null;
	let i;
	for (i = 0; i < pathArr.length; i++) {
		if (i === pathArr.length - 1 && typeof value !== 'undefined') {
			scope[pathArr[i]] = value;
		} else if (!scope.hasOwnProperty(pathArr[i])) {
			scope[pathArr[i]] = {};
		}
		scope = scope[pathArr[i]];
	}
	return scope;
};

/**
 * Function to parse stringified plain JS objects.
 * Theese are used over classic JSON in case of need to use single quotes over double quotes.
 * E.g. config object written into HTML element's attribute.
 * @param {string} str Stringified plain JS Object. Value has to be string starting and ending with curly braces (leading and trailing white-spaces are acceptable).
 * @returns {Object} Plain JS Object parsed from passed string.
 */
EBContext.utils.parseObj = function (str) {
	var parsedObj = {};
	if (!!str && typeof str === 'string') {
		str = str.trim();
		if (str[0] === '{' && str.slice(-1) === '}') {
			try {
				parsedObj = eval('(' + str + ')'); // jshint ignore:line
			} catch (errCode) {
				console.error('%cError parsing object!', EBContext.options.consoleStyles.errorMsg);
				console.error(errCode);
				console.groupCollapsed("%cShow code", EBContext.options.consoleStyles.infoBtn);
				console.warn('%c' + str, EBContext.options.consoleStyles.code);
				console.groupEnd();
			}
		} else {
			console.error('%cPassed string doesn\'t ressemble JS object. Object has to begin and end with curly braces!', EBContext.options.consoleStyles.errorMsg);
		}
	} else if (str) {
		console.error('%cPassed argument has to be stringified JS object!', EBContext.options.consoleStyles.errorMsg);
	}
	return parsedObj;
};

/**
 * Function to convert params string (key/value pairs stringified to queryString-like string) into a plain JS Object (just one level key/value pairs).
 * @param {string} paramsStr Input parameter string. Can start with '?', then must match to pattern 'key1=value1&key2=value2&key3=value3' etc... 
 * @param {boolean} keysToLowerCase Set whether keys of parsed object will be transformed to lowercase, or not. This is usefult for merging params without duplicates.
 * @returns {Object} Plain JS Object of key/value pairs from 'paramsStr', where keys might be transformed to lowercase (depending on 'keysToLowerCase' parameter), and values are URIComponent-decoded
 */
EBContext.utils.paramsStrToObj = function (paramsStr, keysToLowerCase) {
	if (paramsStr[0] === '?') paramsStr = paramsStr.slice(1);
	var paramsObj = {};
	if (paramsStr !== '') {
		var pairs = paramsStr.split('&');
		for (var i = 0; i < pairs.length; i++) {
			var pair = pairs[i].split('=');
			if (keysToLowerCase) pair[0] = pair[0].toLowerCase();
			paramsObj[pair[0]] = decodeURIComponent(pair[1] || '');
		}
	}
	return paramsObj;
};

/**
 * Function to convert plain JS Object (just one level key/value pairs) to params string (key/value pairs stringified to queryString-like string).
 * @param {Object} paramsObj One-level plain JS Object of key/value pairs.
 * @param {boolean} [encodeValues] Boolean to set whether values in params string will be URIComponent-encoded or not.
 * @returns {string} Returns string of 'paramsObj' key/value pairs matching 'key1=value1&key2=value2&key3=value3' etc., where values might be URIComponent-encoded, depending on 'encodeValues' parameter.
 */
EBContext.utils.paramsObjToStr = function (paramsObj, encodeValues) {
	if (encodeValues === undefined) encodeValues = true;
	var pairs = [];
	for (var key in paramsObj) {
		let val = paramsObj[key];
		if(typeof val === 'object') val = JSON.stringify(val);
		if(encodeValues) val = encodeURIComponent(val)
		pairs.push(key + '=' + val);
	}
	return pairs.join('&');
};

EBContext.utils.search = function(obj, str){
    if(!obj) return obj;
	if(Array.isArray(obj)) return obj.filter(a=>EBContext.utils.search(a, str));
    if(typeof obj === 'object'){
		let ent = Object.entries(obj);
        let keyObj = Object.fromEntries(ent.filter(a=>a[0].indexOf(str)>-1));
        let recObj = Object.fromEntries(ent.map(a=>{
            let rec = EBContext.utils.search(a[1], str);
            if(Array.isArray(rec) && !rec.length) return undefined;
            if(rec && typeof rec === 'object' && !Object.keys(rec).length) return undefined;
            if(rec) return [a[0],rec];
            return undefined;
        }).filter(a=>a!==undefined));
        let fObj = EBContext.utils.mergeObj(false, keyObj, recObj);
     	return fObj;
	}		
	if(typeof obj !== 'function' && obj.toString().indexOf(str)>-1){
        console.info('found string "%s" in string: ', str, obj.toString(), obj);
        return obj;
    }
	return undefined;
};

EBContext.utils.form = EBContext.utils.form || {};
/**
 * This function tries to mimic standard form serialization as if normally submited.
 * For example it handles serialization of multiple values (from elements with same names),
 * serialization of inputs without their respective values (select),
 * and skipping disabled form elements (and elements in disabled fieldsets.)
 * @param {HTMLFormElement} form Reference to Form HTML DOM Element.
 * @param {boolean} [skipSerialization] If `true` then returns object of form values, else returns string
 * @returns {string|null|Object} Plain JS object or Key/value pairs in queryString-like format, where keys are names of named form elements and values are their URIComponent-encoded values.
 */
EBContext.utils.form.serialize = function (form, skipSerialization) {
	if (!form || typeof form !== 'object' || form.constructor.name !== 'HTMLFormElement') {
		console.error('%c@serializeForm: Form element is missing or is not "FORM" HTMLElement!', EBContext.options.consoleStyles.errorMsg);
		return null;
	}
	let i, element, elementName, elementValue, elementDataName;
	let paramsObj = {};
	for (i = 0; i < form.length; i++) {
		element = form[i];

		// Do not return elements that are disabled, are in a disabled fieldset, or in a disabled form
		if(!element.getAttribute('name') || !EBContext.utils.element.isEnabled(element,form)) continue;
		
		elementName = element.getAttribute('name');
		elementValue = (element.hasAttribute('data-value') ? element.getAttribute('data-value') : element.value);
		if (element instanceof HTMLInputElement) {
			switch (element.getAttribute('type').toLowerCase()) {
				case 'checkbox':
				case 'radio':
					if (!(elementName in paramsObj)) paramsObj[elementName] = '';
					if (element.checked) {
						if (paramsObj[elementName]) paramsObj[elementName] += ',';
						paramsObj[elementName] += (skipSerialization ? elementValue : encodeURIComponent(elementValue));
					}
					break;
				case 'submit':
					if (element === document.querySelector('input:hover')) { // �e�it to p�es hover je asi je�t� hor�� ne� document.activeElement,ale jestli to bude fungovat, tak je to nejjednodu��� �e�en�
						if (paramsObj[elementName]) paramsObj[elementName] += ',';
						paramsObj[elementName] += (skipSerialization ? elementValue : encodeURIComponent(elementValue));
					}
					break;
				default:
					if (!paramsObj.hasOwnProperty(elementName)) paramsObj[elementName] = '';
					if (paramsObj[elementName] !== '') paramsObj[elementName] += ',';
					paramsObj[elementName] += (skipSerialization ? elementValue : encodeURIComponent(elementValue));
					break;
			}
		} else if (element instanceof HTMLButtonElement){
			continue; // identifikaci a serializaci stisknut�ho buttonu �e�� EBContext.utils.prepareForm
		} else if (element instanceof HTMLSelectElement) {
			if (!(elementName in paramsObj)) paramsObj[elementName] = '';
			if (element instanceof HTMLSelectElement) {
				for (var j = 0; j < element.options.length; j++) {
					if ((element.options[j].hasAttribute('data-value') || element.options[j].hasAttribute('value')) && element.options[j].selected) {
						if (paramsObj[element.name] !== '') paramsObj[element.name] += ',';
						elementValue = (element.options[j].hasAttribute('data-value') ? element.options[j].getAttribute('data-value') : element.options[j].value);
						paramsObj[element.name] += (skipSerialization ? elementValue : encodeURIComponent(elementValue));
					}
				}
			}
		} else if (element instanceof HTMLTextAreaElement) {
			if (!paramsObj.hasOwnProperty(elementName)) paramsObj[elementName] = '';
			if (paramsObj[elementName] !== '') paramsObj[elementName] += ',';
			paramsObj[elementName] += (skipSerialization ? elementValue : encodeURIComponent(elementValue));
		} else {
			console.error('%c@serializeForm: Element \'' + (element instanceof HTMLElement ? EBContext.utils.element.getSelector(element) : element.toString()) + '\' is not valid form control element!', EBContext.options.consoleStyles.errorMsg);
		}
		elementDataName = element.getAttribute('data-name');
		if(elementDataName) paramsObj[elementDataName] = paramsObj[elementName];
	}
	if (skipSerialization) return paramsObj;
	return EBContext.utils.paramsObjToStr(paramsObj, false);
};
EBContext.utils.form.process = function(form, options){
	if(!EBContext.utils.validateForm(form)) return false;
	let formOptions = EBContext.utils.parseObj(form.getAttribute('data-ajax'));
	options = EBContext.utils.extendObj(false, formOptions, options);
	options.reload = options.reload || EBContext.ajaxNav.options.defaultReload.join(',');
	let virtualAnchor = EBContext.utils.createAnchor(form);
	options.ctype = (options.hasOwnProperty('ctype') ? options.ctype : form.enctype) || '';
	if(options.overrideURL) virtualAnchor.href = options.overrideURL;
	
	let postData = options.postData || null, formData;
	if (options.ctype.toLowerCase() === 'multipart/form-data') {
		formData = new FormData(form);
	} else {
		formData = EBContext.utils.serializeForm(form, true);
	}
	if (!form.method || form.method.toLowerCase() === 'get') {
		if(options.linkMask){
			virtualAnchor.href = EBContext.utils.replaceMask('/'+options.linkMask, formData, true);
		}
		if (options.extendQS) {
			virtualAnchor.href = EBContext.utils.extendURL(virtualAnchor.href, formData, true);
		} else {
			virtualAnchor.href = virtualAnchor.href.split('?')[0] + '?' + EBContext.utils.paramsObjToStr(formData, true);
		}
	} else {
		postData = formData;
	}
	let ajaxURL = EBContext.utils.createAjaxURL(virtualAnchor, options);
	virtualAnchor.href = EBContext.utils.createURL(virtualAnchor, options);
	return {virtualAnchor:virtualAnchor, ajaxURL:ajaxURL, postData:postData, options:options};
};
EBContext.utils.form.clearField = function(field, form, submit, value){
	if(typeof form === 'string') form = document.querySelector(form); //mo�no p�edat selector
	if(form && typeof field === 'string') field = [...form.elements].filter(el=>((el.matches(field) || el.name === field) && (value === undefined || value === null || el.value === value)));
	if(!field) return;
	if(!Array.isArray(field)) field = [field];
	field.forEach(f=>{
		if(f.type !== 'hidden' && !f.disabled && !f.readOnly){
			if(f.type === 'checkbox' || f.type === 'radio'){
				f.checked = false;
			} else {
				f.value = (f.tagName === 'SELECT' && f.querySelector('option[value=""]') ? '' : null);
				if(f.matches('select.selectpicker')) require(['jquery','bootstrap-select-config'], ()=>{jQuery(f).selectpicker('refresh')});
			}
		}
	});
	if(submit) EBContext.utils.form.submit(form);
};
EBContext.utils.form.clear = function(form, submit){
	if(typeof form === 'string') form = document.querySelector(form); //mo�no p�edat selector
	if(form instanceof HTMLElement && form.nodeName !== 'FORM') form = form.form || form.closest('form'); //mo�no referencovat libovoln� element formu - typicky reset btn. s `onclick="EBContext.utils.resetForm(this)"`
	if(!form) return; //pokud se ani tak nenajde, tak returnovat, a� necrashne s chybou
	[...form.elements].forEach(EBContext.utils.form.clearField);
	if(submit) EBContext.utils.form.submit(form);
};
EBContext.utils.form.validate = function(form){
	if (!form || typeof form !== 'object' || form.constructor.name !== 'HTMLFormElement') {
		console.error('%c@serializeForm: Form element is missing or is not "FORM" HTMLElement!', EBContext.options.consoleStyles.errorMsg);
		return null;
	}
	let i, element, elementName, val, elementDataName;
	let paramsObj = {};
	for (i = 0; i < form.length; i++) {
		element = form[i];

		// Do not return elements that are disabled, are in a disabled fieldset, or in a disabled form, do not return readonly fields
		if(!element.getAttribute('name') || !EBContext.utils.element.isEnabled(element,form) || element.readOnly) continue;
		
		if(element instanceof HTMLSelectElement){
			element.setCustomValidity(element.required && [...element.selectedOptions].find(el=>el.disabled) ? EBContext.resource('MSG_DISABLED_OPTION') : '');
			element.changeCallback = el=>el.setCustomValidity('');
		}
		
		if(!element.checkValidity()){
			element.reportValidity();
			return false;
		}
	}
	return true;
};
EBContext.utils.form.prepare = function(form){
	if (!form || typeof form !== 'object' || form.constructor.name !== 'HTMLFormElement') {
		console.error('%c@prepareForm: Form element is missing or is not "FORM" HTMLElement!', EBContext.options.consoleStyles.errorMsg);
		return null;
	}
	let i, j;
	let hiddenEl = document.createElement('input');
		hiddenEl.type='hidden';
		hiddenEl.value='';
		form.appendChild(hiddenEl);
	for (i = 0; i < form.length; i++) {
		let element = form[i];
		if(!element.getAttribute('name')) continue;
		let type = element.getAttribute('type');
		if(type && type.toLowerCase()==='submit'){
			EBContext.utils.element.setOverride(element, 'onclick', e=>{
				var ctEl = e.currentTarget;
				hiddenEl.value = ctEl.value;
				hiddenEl.name = ctEl.name;
				ctEl.name = '';
				setTimeout(()=>{
					ctEl.name = hiddenEl.name;
					hiddenEl.name = '';
				}, 100);
			});
		}
		
	}
	return true;
};
EBContext.utils.form.submit = function(form, errCallback){
	if (!form || typeof form !== 'object' || form.constructor.name !== 'HTMLFormElement') {
		console.error('%c@prepareForm: Form element is missing or is not "FORM" HTMLElement!', EBContext.options.consoleStyles.errorMsg);
		return;
	}
	let submitattempts = parseInt(form.getAttribute('submitattempts')) || 0;
	if(submitattempts > 100){
		EBContext.confirm('P�ekro�en po�et ne�sp�n�ch odesl�n� formul��e. Obnovit str�nku?', resp=>{if(resp) window.location.reload()});
		return;
	} else {
		form.setAttribute('submitattempts', ++submitattempts);
		if(errCallback && typeof errCallback === 'function') return errCallback(form);
	}
	let submitBtn = form.querySelector('[type="submit"]'); //bl�e nespecifikovat! M��e b�t input, nebo taky button!
	if(submitBtn) return submitBtn.click();
	submitBtn = document.createElement('button');
	submitBtn.type='submit';
	submitBtn.style.display='none';
	form.appendChild(submitBtn);
	submitBtn.click();
	form.removeChild(submitBtn);
};
EBContext.utils.form.confirmSubmit = function(form, message, options){
	let validity = EBContext.utils.form.validate(form);
	if(!validity) return false;
	if(form['confirmSubmit']===true) return true;
	EBContext.await('EBContext_Modal', ()=>{
		EBContext.confirm(message, resp=>{
			if(resp){
				form['confirmSubmit'] = true;
				EBContext.utils.form.submit(form);
				form['confirmSubmit'] = false;
			} else if(options.resetOnCancel){
				form.reset();
			}
		}, options);
	});
	return false;
};

//@ALIAS @DEPRICIATED
EBContext.utils.clearForm = EBContext.utils.form.clear;
EBContext.utils.prepareForm = EBContext.utils.form.prepare;
EBContext.utils.processForm = EBContext.utils.form.process;
EBContext.utils.validateForm = EBContext.utils.form.validate;
EBContext.utils.serializeForm = EBContext.utils.form.serialize;

/**
 * @param {string|HTMLAnchorElement|Location|URL|HTMLFormElement} [url] Parameter 'url' needs to be either string, Location, URL, HTMLFormElement or HTMLAnchorElement reference. If unset, current location is used
 * @returns {HTMLAnchorElement} Virtual HTMLAnchorElement, with 'href' from passed param 'url', and 'data-ajax' if passed 'url' is in fact HTMLElement
 */
EBContext.utils.createAnchor = function (url) {
	if (!url) {
		url = window.location.href;
	} else if (url instanceof HTMLAnchorElement) {
		return url;
	}

	/**@type {HTMLAnchorElement} */
	var virtualAnchor = document.createElement('a');

	if (typeof url === 'string') {
		virtualAnchor.href = url;
	} else if (url instanceof Location || url instanceof URL) {
		virtualAnchor.href = url.href;
	} else if (url instanceof HTMLFormElement) {
		virtualAnchor.href = url.getAttribute('action') || window.location.href;
	} else console.error('%c@createAnchor: Invalid parameter "url"! Parameter "url" accepts string, Location or HTML Anchor element.', EBContext.options.consoleStyles.errorMsg);
	if (url instanceof HTMLElement) {
		if (url.getAttribute('data-ajax') !== null) virtualAnchor.setAttribute('data-ajax', url.getAttribute('data-ajax'));
		if (url.getAttribute('target') !== null) virtualAnchor.setAttribute('target', url.getAttribute('target'));
	}
	return virtualAnchor;
};

/**
 * @typedef {Object} EBContext.navigationOptions
 * @property {boolean} [navigation=true] Defines, whether is the request navigational or not 
 * @property {Object.<string,(string|number)>} [requestParams] plain JS object of queryString params to extend link's href with
 * @property {boolean} [extendQS=false] if `true`, passed 'requestParams' will extend queryString parameters in link's href instead of overriding them
 * @property {string} [reload] Comma-separated list of blocks to update
 */

/**
 * This function extends given URL according to options
 * @param {(string|HTMLAnchorElement|Location)} url Parameter 'url' needs to be either string, Location or HTMLAnchorElement reference
 * @param {EBContext.navigationOptions} options 
 * @returns {string} URL extended with options
 */
EBContext.utils.createURL = function (url, options) {
	var virtualAnchor = EBContext.utils.createAnchor(url);
	options = options || {};
	if (virtualAnchor.getAttribute('data-ajax') !== null)
		options = EBContext.utils.extendObj(true, EBContext.utils.parseObj(virtualAnchor.getAttribute('data-ajax')), options);
	var requestParams = options.requestParams || {};
	requestParams = EBContext.utils.extendObj(EBContext.utils.paramsStrToObj(virtualAnchor.href.toString().split('#')[0].split('?')[1] || '', false), requestParams);
	if (options.extendQS)
		requestParams = EBContext.utils.extendObj(EBContext.utils.paramsStrToObj(window.location.href.toString().split('#')[0].split('?')[1] || '', false), requestParams);
	for (var key in requestParams)
		if (requestParams[key] === '')
			delete requestParams[key];
	var queryString = EBContext.utils.paramsObjToStr(requestParams, true);
	return virtualAnchor.pathname + (queryString.length > 0 ? '?' + queryString : '');
};

/**
 * This function extends given URL with passed parameters
 * @param {(string|HTMLAnchorElement|Location)} url Parameter 'url' needs to be either string, Location or HTMLAnchorElement reference
 * @param {Object.<string, string>} params Plain JS Object of key/value pairs to stringify and extend given URL with
 * @returns {string} passed URL (or URL of passed object) extended with passed params
 */
EBContext.utils.extendURL = function (url, params, keepEmpty) {
	if (!url) url = window.location.href;
	if (typeof params === 'string') params = EBContext.utils.paramsStrToObj(params, false);
	var virtualAnchor = EBContext.utils.createAnchor(url);
	var requestParams = EBContext.utils.extendObj(EBContext.utils.paramsStrToObj(virtualAnchor.href.toString().split('?')[1] || '', true), params);
	if(!keepEmpty){
		for (var key in requestParams)
			if (requestParams[key] === '')
				delete requestParams[key];
	}
	var queryString = EBContext.utils.paramsObjToStr(requestParams, true);
	return virtualAnchor.pathname + (queryString.length > 0 ? '?' + queryString : '');
};

/**
 * This function extends given URL according to options and transforms it to AJAX call format
 * @param {(string|HTMLAnchorElement|Location)} url Parameter 'url' needs to be either string, Location or HTMLAnchorElement reference
 * @param {EBContext.navigationOptions} [options]
 * @returns {string} passed URL extended with AJAX parameters
 */
EBContext.utils.createAjaxURL = function (url, options) {

	/**@type {HTMLAnchorElement} */
	var virtualAnchor = EBContext.utils.createAnchor(url);

	/**@type {Object.<string, *>} */
	options = options || {};

	if (virtualAnchor.getAttribute('data-ajax') !== null) {
		options = EBContext.utils.extendObj(true, EBContext.utils.parseObj(virtualAnchor.getAttribute('data-ajax')), options);
	}
	
	//Nejprve se QS parametry vezmou z options
	/**@type {Object.<string,(string|number)>} */
	var requestParams = options.requestParams || {};

	requestParams = EBContext.utils.extendObj(EBContext.utils.paramsStrToObj(virtualAnchor.href.toString().split('?')[1] || '', false), requestParams);

	//Pokud je zapnut� roz���en� parametr�, na�tou se parametry z url, a roz���� se t�mi z options
	if (options.extendQS) {
		requestParams = EBContext.utils.extendObj(EBContext.utils.paramsStrToObj(window.location.href.toString().split('?')[1] || '', false), requestParams);
	}
	
	if (typeof options.call === "string"){
		let callArr = options.call.split('.');
		requestParams.ebpageitemcall = callArr[0];
		requestParams.ebpageitemmethod = callArr[1];
	}
	
	//Nakonec se objekt s parametry roz���� parametry povinn�mi pro AJAX request
	requestParams.ajax = '1';
	requestParams.ebpageitemupdate = options.reload || requestParams.ebpageitemupdate || '';

	//v p��pad�, �e odkaz sm��uje na index, a je v EBContext nastaveno jeho OID, p�ed� se (toto je blbuvzdorn� fallback), jinak se zkus� p�edat path='/', co� ale asi je�t� nefunguje v�ude 
	if (virtualAnchor.pathname == '/' && typeof EBContext.options.defaultPage === 'string' && EBContext.options.defaultPage.length === 12) {
		requestParams.ebpageoid = EBContext.options.defaultPage;
	} else if (virtualAnchor.pathname == '/' && !requestParams.ebpageoid && !requestParams.path) {
		// requestParams.path = '/';
	}
	return virtualAnchor.pathname + '?' + EBContext.utils.paramsObjToStr(requestParams, true);
};

EBContext.utils.updateURL = function (url, params){
	window.history.replaceState(history.state, "", EBContext.utils.extendURL(url, params, false));
};

/**
 * Templating engine utilizing HTML comments, so untranslated variables wouldn't appear on page, and code is self-documented.
 * Only string template values will be proccessed recursively, others will be only stringified and inserted.
 * Template references may use dot notation according to structure of templates object
 * @param {string} templateStr Text/HTML containing HTML comments as references for templates
 * @param {Object} [templates] Plain JS Object of templates, where key is template name and value is array of two strings for pair template, string for single template or any value to be stringified
 * @param {Object} [variables] Plain JS Object of variables to be replaced into templates
 * @param {Boolean} [plaintext] if `true` then returns string, else returns NodeList
 * @returns {string|NodeList} TemplateStr with replaced references for their templates (if found)
 */
EBContext.utils.template = function (templateStr, templates, variables, plaintext) {
	let templatesCache = {};
	let activeReferences = {};
	let rootVariables = variables;
	let debug = false;
	var evtRefs = {};

	var findTemplate = function (templateName, templates, variables, storeCache, params) {
		let parentParams = params;
		let parentVariables = variables;
		if(templateName === '!debug' && EBContext.options.serviceMode){
			debug = true;
			return '';
		} else if(templateName === '!!debug'){
			debug = false;
			return '';
		}
		if (!templatesCache.hasOwnProperty(templateName)) {
			let type = templateName.substring(0, 1);
			let tempArr = templateName.split(';');
			let valArr = null, arrFrom, arrTo;
			let evtName = '';
			templateName = tempArr[0];
			let i;
			if (tempArr.length > 1) {
				for (i = 1; i < tempArr.length; i++) {
					let objRef = tempArr[i];
					let objType = objRef.substring(0, 1);
					if (objType === '$' || objType === '~') {
						let toArr = (objRef.substring(1, 2) === ':');
						if(objRef.indexOf('[') > -1){
							let tempArr2 = objRef.split('[');
							objRef = tempArr2[0];
							tempArr2 = tempArr2[1].replace(']', '').split(':');
							arrFrom = parseInt(tempArr2[0]) || undefined;
							arrTo = parseInt(tempArr2[1]) || undefined;
						}
						variables = EBContext.utils.searchObj((objType === '~' ? rootVariables : variables), objRef.slice( (toArr ? 2 : 1) ).split('.'));
						valArr = (toArr ? Object.values(variables) : null);
						if(debug) console.debug('Associated variables: ', variables);
					} else if (objType === '#') {
						templates = EBContext.utils.searchObj(templates, objRef.slice(1).split('.'));
						if(debug) console.debug('Associated templates: ', templates);
					}
				}
			}
			if(type==='!'){
				let evtArr = templateName.split('@');
				if(evtArr.length>1){
					type = '@';
					evtName = evtArr[0].slice(1);
					templateName = '@' + evtArr.slice(1).join('@');
				}
			}
			if ('$~@'.indexOf(type) > -1) {
				if(templateName.indexOf('~resource.') === 0){
					let resId = templateName.slice(10);
					if(resId && '~$@'.indexOf(resId[0]) > -1) resId = findTemplate(resId, templates, variables, null, params);
					let resText = EBContext.resource(resId);
					if(debug) console.debug('Resource `' + resId + '` translated to `' + resText + '`.');
					return resText;
				}
				if(!rootVariables){
					if(debug) console.error('Missing root variables! Returning templateName: `' + templateName + '`.');
					return templateName;
				}
				tempArr = templateName.split('?');
				if(tempArr.length > 1){
					let cond = EBContext.utils.searchObj((type === '$' ? variables : rootVariables), tempArr[0].slice(1).split('.'));
					if(debug){
						console.groupCollapsed('Template condition: `' + tempArr[0] + '`');
						console.debug('Condition references: ', cond);
					}
					if(typeof cond === 'function'){
						cond = cond(variables, params, rootVariables);
						if(debug){
							console.debug('Condition reference is a function. Calling function with attributes `variables` and `params`. Result: ', cond);
							console.debug('variables: ', variables);
							console.debug('params: ', params);
						}
					}
					tempArr = (tempArr[1]+':').split(':');
					if(cond && typeof cond === 'object'){
						cond = Object.keys(cond).length;
						if(debug) console.debug('Condition reference is an Object. Checking keys length > 0. Result: ', cond);
					}
					if(debug){
						console.debug('Condition is ' + !!cond + '. Searching for template in `' + tempArr[(cond ? 0 : 1)] + '`');
						console.groupEnd();
					}					
					if (cond) {
						return findTemplate(tempArr[0], templates, variables, null, params);
					} else {
						return findTemplate(tempArr[1], templates, variables, null, params);
					}
				}
				tempArr = templateName.split('@');
				if(tempArr.length > 1){
					let fn = EBContext.utils.searchObj(rootVariables, tempArr[tempArr.length-1]);
					let val = (tempArr[0] ? EBContext.utils.searchObj((type === '~' ? rootVariables : variables), tempArr[0].slice(1)) : variables);
					if(debug){
						console.groupCollapsed('Parsing template function `' + tempArr[tempArr.length-1] + '`');
						console.debug('Function: ', fn);
						console.debug('Call parameter: ', val);
					}
					if(typeof fn === 'function'){
						if(evtName){
							let evtRef;
							do{
								evtRef = 'evtRef_' + Math.floor(Math.random() * 1000000).toString();
							} while(evtRefs.hasOwnProperty(evtRef));
							evtRefs[evtRef] = {
								eventName: evtName,
								callback: fn,
								variables: variables,
								params: params
							};
							if(debug){
								console.debug('Inserting event reference: ', evtRef);
								console.groupEnd();
							}
							return ' ' + evtRef + ' ';
						}
						let fnRes = fn(val, params, rootVariables);
						if(debug){
							console.debug('Function call result: ', fnRes);
							console.groupEnd();
						}
						return parseTemplate(fnRes, templates, variables, storeCache, params);
					}
					if(debug){
						console.error('Reference is not a function!', fn);
						console.groupEnd();
					}
				}
				if(templateName === '$'){
					if(debug) console.debug('Return:', variables);
					return variables;
				}
				let tmpVars = EBContext.utils.searchObj((type === '~' ? rootVariables : variables), templateName.slice(1)) || '';
				if(debug) console.debug('Return:', tmpVars);
				return tmpVars;
			}
			if (!templates || type === '"') return templateName.slice(1, -1);
			let respStr = '';
			let tempVars;
			if (Array.isArray(variables)) {
				storeCache = false;
				tempVars = variables;
			}
			else if(valArr && valArr.length > 0){
				storeCache = false;
				tempVars = valArr;
			}
			else {
				tempVars = [variables];
			}
			if(arrFrom !== undefined || arrTo !== undefined){
				tempVars = tempVars.slice(arrFrom, arrTo);
			}
			if(Array.isArray(parentVariables) && parentParams) parentVariables = parentVariables[params.i];
			if(variables===parentVariables && parentParams) parentVariables = parentParams.parentVariables;
			params = {n: tempVars.length};
			for (i = 0; i < tempVars.length; i++) {
				params.i = i;
				params.parentParams = parentParams;
				params.parentVariables = parentVariables;
				if (templatesCache.hasOwnProperty(templateName)) {
					respStr += templatesCache[templateName];
				} else {
					let template = EBContext.utils.searchObj(templates, templateName.slice(1).split('.'));
					if (template) {
						if (typeof template === 'string') {											// Libovoln� string (nap�. nep�rov� tag)
							respStr += parseTemplate(template, templates, tempVars[i], null, params);
						} else if (type === '#' && Array.isArray(template) && template.length > 0) { // Otev�rac� p�rov� tag
							respStr += parseTemplate(template[0], templates, tempVars[i], null, params);
						} else if (type === '/' && Array.isArray(template) && template.length > 1) { // Zav�rac� p�rov� tag
							respStr += parseTemplate(template[1], templates, tempVars[i], null, params);
						} else {
							respStr += template.toString();
						}
					} else {
						console.warn('%c@template: Template \'' + templateName + '\' not found!', EBContext.options.consoleStyles.warnMsg);
					}
				}
			}
			if (storeCache) {
				templatesCache[templateName] = respStr;
				if(debug) console.debug('Storing template `' + templateName + '` in cache: ', templatesCache);
			}
			return respStr;
		} else {
			if(debug) console.log('Returning template `' + templateName + '` from cache: ', templatesCache);
		}
		return parseTemplate(templatesCache[templateName], templates, variables, storeCache);
	};

	var parseTemplate = function (templateStr, templates, variables, storeCache, params) {
		if(typeof templateStr !== 'string') return templateStr;
		if(templateStr.indexOf('<!--!debug-->') === 0 && EBContext.options.serviceMode){
			debug = true;
			templateStr = templateStr.substr(13);
		}
		let references = templateStr.match(/(?:<\!\-\-[\#\/\$~@!])((?!\-\-\>).)*(\-\-\>)/g);
		// let references = templateStr.match(/(?:<\!\-\-[\#\/\$\?\:\~])((?!\-\-\>).)*(\-\-\>)/g);
		if(debug) console.groupCollapsed('Parsing `' + templateStr + '`');
		let debug2 = debug;
		if (references) {
			for (let i = 0; i < references.length; i++) {
				let reference = references[i].replace('<!--', '').replace('-->', '');
				if(reference.substr(-1) === '!'){
					reference = reference.slice(0,-1);
				}
				let ari = activeReferences[reference];
				if(debug) console.groupCollapsed('Processing reference `' + reference + '`');
				let debug2 = debug;
				if (ari && ari > 100) {
					console.error('%c@template: Cyclic definition of \'' + reference + '\' exceeding 100 recursions! Recursion terminated.', EBContext.options.consoleStyles.errorMsg);
				} else {
					activeReferences[reference] = activeReferences[reference] || 0;
					activeReferences[reference]++;
					templateStr = templateStr.replace(references[i], findTemplate(reference, templates, variables, storeCache, params));
					activeReferences[reference]--;
				}
				if(debug2) console.groupEnd();
			}
		}
		if(debug){
			//console.debug('templates: ', templates);
			console.debug('variables: ', variables);
			if(params) console.debug('params: ', params);
			console.debug('Return: ', templateStr);
			console.groupEnd();
		} else if(debug2) console.groupEnd();
		return templateStr;
	};
	if(debug){
		console.group('DEBUG TEMPLATE: ' + templateStr);
		console.debug('templates: ', templates);
		console.debug('variables: ', variables);
	}
	let ret;
	if(plaintext){
		ret = parseTemplate(templateStr, templates, variables, true);
	} else {
		ret = EBContext.utils.createDOM(parseTemplate(templateStr, templates, variables, true));
		for(ref in evtRefs){
			let refObj = evtRefs[ref];
			[...ret].forEach(retEl=>{
				let cb = el=>{
					el.addEventListener(refObj.eventName, e=>refObj.callback(e,el,refObj.variables,refObj.params));
					el.removeAttribute(ref);
					delete evtRefs[ref];
				};
				if(retEl.matches('[' + ref + ']')) cb(retEl);
				[...retEl.querySelectorAll('[' + ref + ']')].forEach(cb);				
			});
		}
	}
	if(debug) console.groupEnd();
	return ret;
};

/**
 * Function to parse template string into collection of HTML nodes
 * @param {string} templateStr String of HTML code to convert
 * @returns {NodeList} List of nodes parset from input string `templateStr`
 */
EBContext.utils.createDOM = function (templateStr) {
	var wrapEl;
	var leadingTag = templateStr.match(/<(?!\!--)[^>]*>/);
	var leadingTagName = (leadingTag ? leadingTag.toString().match(/[a-zA-Z0-9]+/).toString().toLowerCase() : 'div');
	switch (leadingTagName) {
		case 'tr':
		case 'caption':
		case 'thead':
		case 'tbody':
		case 'tfoot':
		case 'colgroup':
			wrapEl = 'table';
			break;
		case 'td':
		case 'th':
			wrapEl = 'tr';
			break;
		case 'optgroup':
		case 'option':
			wrapEl = 'select';
			break;
		case 'dt':
		case 'dd':
			wrapEl = 'dl';
			break;
		case 'rp':
		case 'rt':
			wrapEl = 'ruby';
			break;
		case 'source':
		case 'track':
			wrapEl = 'video';
			break;
		case 'area':
			wrapEl = 'map';
			break;
		case 'summary':
			wrapEl = 'detail';
			break;
		case 'col':
			wrapEl = 'colgroup';
			break;
		case 'figcaption':
			wrapEl = 'figure';
			break;
		case 'legend':
			wrapEl = 'fieldset';
			break;
		case 'param':
			wrapEl = 'object';
			break;
		default:
			wrapEl = 'div';
			break;
	}
	var wrapElObj = document.createElement(wrapEl);
	wrapElObj.innerHTML = templateStr;
	return wrapElObj.childNodes;
};
EBContext.utils.xmlHttp = function (params) {
	params = EBContext.utils.extendObj(false, {
		url: window.location.href,
		method: 'GET',
		data: null,
		ctype: null,
		charset: null,
		headers: null,
		callback: null,
		asyn: true,
		responseType: '',
		timeout: 300000,
		user: null,
		password: null
	}, params);

	if (!window.XMLHttpRequest) { // If browser doesn't support XMLHttpRequest then throw error msg and exit
		alert(EBContext.resource('USR_browserWithoutXMLHTTP'));
		return false;
	}
	let expectedURL = window.location.origin + params.url;
	let xhr = new XMLHttpRequest();
	xhr.open(params.method, params.url, params.asyn, params.user, params.password);

	if (params.data && ['POST', 'PUT', 'PATCH'].indexOf(params.method) > -1) { // Theese methods have request body, therefore needs to have set content-type
		params.ctype = params.ctype || 'application/x-www-form-urlencoded'; // If the content-type is not set, fallback to default FORM content type
	}
	if (params.ctype && !(params.data instanceof FormData)) { // If the content-type is set (method DELETE may or may not have body), set it to XMLHttpRequest
		xhr.setRequestHeader("Content-type", params.ctype + (params.charset ? '; charset=' + params.charset : '') + (params.boundary ? '; boundary=' + params.boundary : ''));
	}
	if (params.headers && typeof params.headers === 'object') { // If there are any additional headers, set them to XMLHttpRequest
		for (var key in params.headers) {
			xhr.setRequestHeader(key, params.headers[key]);
		}
	}

	// If specific response type is required (other than '', which is same as 'text', which is default), then it is passed to XMLHttpRequest
	if (params.responseType) {
		xhr.responseType = params.responseType;
	}

	// If multipoint callback object is passed, set it to callbackObj, and assign callback passed afterEval function
	let callback = params.callback;
	let callbackObj = {};
	if (callback && typeof callback === 'object') {
		callbackObj = callback;
		callback = null;
		if (callbackObj.ok && typeof callbackObj.ok === 'function') callback = callbackObj.ok;
	}
	// If timeout is set, (has not been unset) and timeout
	xhr.timeout = params.timeout;
	xhr.addEventListener('timeout', function () {
		if (callbackObj.timeout && typeof callbackObj.timeout === 'function') callbackObj.timeout(xhr.response, xhr.status, params);
		else if (callbackObj.err && typeof callbackObj.err === 'function') callbackObj.err(xhr.response, xhr.status);
		else if (callback && typeof callback === 'function') callback(xhr.response, xhr.status);
	});

	xhr.onreadystatechange = function () {
		if (xhr.responseURL && xhr.responseURL !== expectedURL){ // XHR has been redirected
			console.debug('xhr has been redirected!');
			console.debug('xhr request url: ', expectedURL);
			console.debug('xhr response url: ', xhr.responseURL);
			expectedURL = xhr.responseURL;
			if(callbackObj.hasOwnProperty('redirect') && typeof callbackObj.redirect === 'function') callbackObj.redirect(expectedURL, xhr);
		}
		if (xhr.status > 399 && xhr.readyState == 4) { // HTTP status codes starting with 400 and above are all error codes
			// if there is designated error callback, call it, else call standard callback, with err. status code
			if (callbackObj.hasOwnProperty('err') && typeof callbackObj.err === 'function') {
				callbackObj.err(xhr.response, xhr.status);
			} else if (callback && typeof callback === 'function') {
				callback(xhr.response, xhr.status);
			}
		} 
		/* 
		 * Kdy� dojde k p�esm�rov�n� s k�dem 302, tak se z POST requestu zahazuj� data. Takov� request by nem�l nic ud�lat, a n�sledn� by se m�l zkusit s POST daty poslat znovu
		 * A� se u POST request� za�ne m�sto 302 spr�vn� vracet 307, tak bude pot�eba toto p�epsat nebo zak�zat, aby se ten request neprov�d�l dvakr�t!
		 */
		if(xhr.status === 307 && xhr.readyState == 4 && params.data && !params.repeated){
			params.repeated = true;
			return EBContext.utils.xmlHttp(params);
		}
		else if(xhr.readyState === 4){ // 4 - DONE - That's all, folks!
			if (xhr.status === 0 && callbackObj.hasOwnProperty('err') && typeof callbackObj.err === 'function') {
				// status 0 - ERR, readyState=4 - final state
				callbackObj.err(xhr.response, xhr.status);
			} else if (callback && typeof callback === 'function') {
				// since there is nothing else, call callback function
				callback(xhr.response, xhr.status);
			}
		}
	};

	var postInterface = EBContext.utils.getObj('myWAC.interface.setPostData');
	if (!EBContext.options.ignoreInterface && params.data && postInterface) {
		postInterface(params.data.replace(/\+/g, '%2B'), undefined, undefined, undefined, function () {
			xhr.send(null);
		});
	} else {
		xhr.send(params.data);
	}
};
EBContext.utils.handleDownload = function(url, options){
	let url2 = url;
	if(url instanceof HTMLElement) url2 = url.href;
	if(typeof(url2) !== 'string') return true; // neplatn� url - nechat event probublat - m��e se zpracov�vat dal��m callbackem
	url2 = new URL(url2, window.location.href); // pokud se vol� handleDownload, stahuje se v�dy ze stejn� baseURL
	if(url2.searchParams.get('noattach')==='1'){
		if(url instanceof HTMLAnchorElement) return true; // volan� na onclick odkazu, kde se jako URL p�ed� "this" (element odkazu) 
		window.open(url, '_blank'); // fallback - kdy� se jako URL p�ed� string s noattach=1
	}
	else {
		EBContext.utils.download(url2, options);
	}
	return false;
};
EBContext.utils.download = function(url, options){
	EBContext.await('EBContext_AjaxNavigation', ()=>{
		var loader = EBContext.ajaxNav.options.loader;
		options = EBContext.utils.extendObj(false, {
			callbackStart: ()=>{ console.log('download start'); loader.fnLoaderStart(loader) },
			callbackFinish: ()=>{ console.log('download finish'); loader.fnLoaderEnd(loader) },
			callbackError: err=>{
				console.error('download error', err || ''); loader.fnLoaderEnd(loader);
				EBContext.alert(EBContext.resource('CHYBA_PRI_STAHOVANI'),null, { heading:EBContext.resource('CHYBA')});
			}
		}, options);
		
		
		if(url){
			options.callbackStart();
			if(typeof window.fetch === 'function'){
				let navStr = navigator.userAgent.toLowerCase();
				/* Zak�z�no kv�li blokov�n� popup oken */
				if(false && navStr.indexOf('firefox') > -1 && (navStr.indexOf('windows') > -1 || navStr.indexOf('macintosh') > -1)){
					url = EBContext.utils.extendURL(url, {noattach:1});
					fetch(url)
						.then(resp=>resp.blob())
						.then(blob=>{
							const url = window.URL.createObjectURL(blob);
							window.open(url, "_blank");
							window.URL.revokeObjectURL(url);
							options.callbackFinish();
						})
						.catch(options.callbackError);
				} else {
					var filename = '';
					fetch(url)
						.then(resp => {
							const cd = resp.headers.get('Content-Disposition');
							if (cd) {
								let re = /(?:filename=\"?)([^\";]*)/g;
								let res = re.exec(cd);
								if (!res) {
									re = /(?:filename\*=UTF-8''\"?)([^\";]*)/g;
									res = re.exec(cd);
									if (res) {
										filename = decodeURIComponent(res[1]);
									}
								}
								else {
									filename = res[1];
								}
							}
							else { // error - bez content-disposition se vrac� jen chyby?
								filename = 'download_error.html';
							}
							return resp.blob();
						})
						.then(blob => {
							if (!filename) {
								blob.text().then(text=>{ 
									options.callbackError(text);
									options.callbackFinish();
								});
								return;
							}
							const url = window.URL.createObjectURL(blob);
							let a = document.createElement('a');
							a.style.display = 'none';
							a.href = url;
							a.download = filename;
							a.target='_blank';
							document.body.appendChild(a);
							a.click();
							window.URL.revokeObjectURL(url);
							a.parentElement.removeChild(a);
							options.callbackFinish();
						})
						.catch(options.callbackError);
				}
			} else {
				var checkInterval;
				var checkState=(ifEl,e)=>{
					if(e) console.log(e);
					var ifDoc = ifEl.contentDocument || (ifEl.contentWindow ? ifEl.contentWindow.document : null);
					if(ifDoc) console.log(ifDoc.readyState);
					if (ifDoc && ifDoc.readyState == 'complete') {
						clearInterval(checkInterval);
				        options.callbackFinish();
				        ifEl.parentElement.removeChild(ifEl);
				    }
				};
				var ifEl = document.getElementById('ifrmDownload');
				if(ifEl) ifEl.parentElement.removeChild(ifEl);
			
				ifEl = document.createElement('iframe');
				ifEl.id = 'ifrmDownload';
				ifEl.style.visibility = 'hidden';
				ifEl.style.height='1px';
				ifEl.style.width='1px';
				ifEl.style.marginLeft='-1px';
				ifEl.onload = e=>checkState(ifEl,e);
				ifEl.onerror = e=>{clearInterval(checkInterval); options.callbackError(); ifEl.parentElement.removeChild(ifEl)};
				checkInterval = setInterval(()=>checkState(ifEl), 100);
				ifEl.src = url;
				document.body.appendChild(ifEl);
			}
		}
	});
};
EBContext.utils.parseMoney = function(money){
	if(typeof money !== 'number'){
		if(typeof money === 'string'){
			money = money.replace(/([^0-9\,\.])/g, '').replace(/\,/g, '.');
		}
		return parseFloat(money);
	}
	return money;
};
EBContext.utils.formatMoney = function(money, decimals){
	decimals = decimals || (decimals === 0 ? 0 : 2);
	try {
		money = EBContext.utils.parseMoney(money);
		let moneyArr = money.toFixed(decimals).split('.');
		return (moneyArr[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ") + (moneyArr.length > 1 ? '.' + moneyArr[1] : '')).replace(/\./g, ',');
	} catch(e){
		console.error(e);
		return NaN;
	}
};
EBContext.utils.replaceMask = function(mask, mapObj, reduceMapObj){
	mask = mask || '';
	let maskRegExp = new RegExp('{.*?}','gi');
	let resp = [...mask.matchAll(maskRegExp)];
	for(let i=0;i<resp.length;i++){
		let maskKey = resp[i][0].slice(1,-1);
		if(mapObj.hasOwnProperty(maskKey)){
			mask = mask.replace(resp[i], encodeURIComponent(mapObj[maskKey]));
			if(reduceMapObj) delete mapObj[maskKey];
		}
	}
	return mask;
};
EBContext.utils.parseMask = function(mask, params, appendEmptyParams){
	let linkURL = EBContext.utils.replaceMask(mask, params, true);
	if(linkURL[0]!=='/' && linkURL.indexOf('http') === -1) linkURL = '/'+linkURL;
	if(!appendEmptyParams) params = Object.fromEntries(Object.entries(params).filter(ent=>!!ent[1]));
	if(Object.keys(params).length > 0) linkURL += '?' + EBContext.utils.paramsObjToStr(params);
	return linkURL;
};

EBContext.utils.grid = EBContext.utils.grid || {};
EBContext.utils.grid.getBreakpoints = function(){
	let bpMap = EBContext.config.widthBreakpoints;
	if(!bpMap){
		bpMap = Object.fromEntries(['xs','sm','md','lg','xl','xxl'].map(a=>[a, parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bs-breakpoint-'+a).replace(/px/g, ''))]));
	}
	EBContext.config.widthBreakpoints = bpMap;
	return EBContext.config.widthBreakpoints;
};
EBContext.utils.grid.getBreakpoint = function(){
	let bpMap = EBContext.utils.grid.getBreakpoints();
	return Object.entries(bpMap).filter(a=>a[1]<=window.innerWidth).sort((a,b)=>(a[1]<b[1]?1:(a[1]>b[1]?-1:0)))[0];
};

/**
 * Namespace for text helper functions
 * @namespace EBContext.utils.text
 */
EBContext.utils.text = EBContext.utils.text || {};

/**
 * Function for getting sensible heading from/for the source text.
 * @param {String} text Source text to make heading of
 * @param {Object} [options] options object for future use
 */
EBContext.utils.text.getHeading = function (text, options) {
	options = EBContext.utils.extendObj({
		maxLength: 0,
		ellipsis: ' ...',
		breakWord: false
	}, options);
	var sentences = text.match(/(^|\s).+?(?=\.(\s|$))/g);
	if (!sentences) return text;
	var heading = sentences[0];
	if (options.maxLength && heading.length > options.maxLength) {
		if (!options.breakWord && heading.substring(options.maxLength - options.ellipsis.length - 1, 3).match(/\s|\./g)) {
			heading = heading.substring(0, options.maxLength - options.ellipsis.length);
			heading = heading.match(/.*(?=\s)/g)[0] || heading;
		}
		heading = heading + options.ellipsis;
	}
	return heading;
};

/**
 * Namespace for HTML DOM Element's helper functions
 * @namespace EBContext.utils.element
 */
EBContext.utils.element = EBContext.utils.element || {};

/**
 * @param {HTMLElement} el HTML Element in a visible DOM tree
 * @returns {boolean} `true` if passed HTMLElement is visible within DOM tree, or `false` otherwise
 */
EBContext.utils.element.isVisible = function (el) {
	if (!document.body.contains(el)) return false;
	var visible = true;
	while (visible && el) {
		var elStyle = window.getComputedStyle(el);
		visible = (elStyle.visibility !== 'hidden' && elStyle.display !== 'none' && el.getAttribute('type') !== 'hidden' && elStyle.opacity !== '0');
		el = el.parentElement;
	}
	return visible;
};

EBContext.utils.element.isTruncated = function (el){
	if(getComputedStyle(el)['-webkit-line-clamp'] !== 'none') return (el.offsetHeight < el.scrollHeight);
	return (el.offsetWidth < el.scrollWidth);
};

/**
 * @param {HTMLElement} el HTML Element to test if is enabled in DOM tree up to scope element
 * @param {HTMLElement} scope HTML Element to limit scope of DOM crawling
 * @returns {boolean} `true` if passed HTMLElement is enabled within given scope, or `false` otherwise
 */
EBContext.utils.element.isEnabled = function (el, scope){
	var isDisabled = el=>(el && (el.disabled || el.hasAttribute('disabled')));
	if(isDisabled(el)) return false;
	scope = scope || el.form || document.body;
	let testEl = el;
	while (testEl !== scope && (testEl.nodeName !== 'FIELDSET' || !isDisabled(testEl))) {
		testEl = testEl.parentElement;
	}
	return (testEl === scope);
}

/**
 * @param {HTMLElement} el HTML Element to create selector from
 * @returns {string} String composed of key element attributes to identify it in DOM tree
 */
EBContext.utils.element.getSelector = function (el) {
	var selector = el.nodeName.toLowerCase();
	selector += (el.id ? '#' + el.id : '');
	selector += (!el.id && el.getAttribute('name') ? '[name="' + el.id + '"]' : '');
	selector += (!el.id && el.className.trim() ? '.' + el.className.trim().replace(/\s+/g, '.') : '');
	selector += (!el.id && el.getAttribute('href') ? '[href="' + el.getAttribute('href') + '"]' : (!el.id && el.getAttribute('action') ? '[action="' + el.getAttribute('action') + '"]' : ''));
	return selector;
};

/**
 * @param {HTMLElement} el HTML Element to crawl for focusable children
 * @returns {string} String composed of key element attributes to identify it in DOM tree
 */
EBContext.utils.element.getFocusableChildren = function(el) {
	if(!EBContext.utils.element.isEnabled(el)) return false;
	return [...el.querySelectorAll('a, button, input, textarea, select, details,[tabindex]')].filter(el2=>(el2.tabIndex > -1 && EBContext.utils.element.isEnabled(el2, el)));
}

/**
 * Overrides ajaxNav after it has been already initialized
 */
EBContext.utils.element.setOverride = function(el, eventName, callback, append){
	var eventHandlerProperty = eventName;
	while(typeof el[eventHandlerProperty] === 'function'){
		eventHandlerProperty = '_' + eventHandlerProperty;
	}
	if(eventHandlerProperty === eventName){
		el[eventName] = callback;
	} else{
		el[eventHandlerProperty] = el[eventName];
		el[eventName] = function(event){
			if(append){
				var resp = el[eventHandlerProperty](event);
				if(resp === undefined) resp = true;
				return resp && callback(event);	
			}
			var resp = callback(event);
			if(resp === undefined) resp = true;
			return resp && el[eventHandlerProperty](event);
		};
	}
};

EBContext.utils.element.getScope = function(scope){
	let retScope = document;
	if (typeof scope === 'string') {
		retScope = [...document.querySelectorAll(scope)];
	} else if (scope instanceof NodeList || scope instanceof HTMLCollection) {
		retScope = [...scope];
	} else if (scope instanceof Element || scope instanceof HTMLDocument) {
		retScope = [scope];
	} else if ((window.jQuery && scope instanceof jQuery) || Array.isArray(scope)) {
		retScope = [];
		for (let i = 0; i < scope.length; i++) {
			if (scope[i] instanceof Element || scope[i] instanceof HTMLDocument) {
				retScope.push(scope[i]);
			}
		}
	}
	return retScope;
};

EBContext.utils.element.getElement = function(ref, scope, all){
	if(!ref) return null;
	if(typeof ref === 'string'){
		let ref2 = ref;
		scope = scope || document;
		let els = scope.querySelectorAll(ref2);
		if(els.length === 1 || (els.length>1 && !all)) return els[0];
		if(els.length > 1) return [...els];
		if(scope !== document && scope.matches(ref2)) return scope;
		if(ref[0] !== '#') return EBContext.utils.element.getElement('#'+ref, scope, all); // pokud by n�kdo p�edal jako ref ID bez #
	}
	if(ref instanceof HTMLElement || ref instanceof HTMLDocument)
		if(!scope || scope.contains(ref) || scope===ref)
			return ref;
	console.warn('%cElement not found within given scope! - Element: %s, Scope: %o', EBContext.options.consoleStyles.warnMsg, ref, scope);			
	return null;
};

EBContext.utils.element.uniqueId = function(el){
	if(el && !(el instanceof HTMLElement)) el = null;
	if(el && el.id && document.getElementById(el.id).length <= 1) return el.id;
	let id, prefix='id';
	if(el) prefix = el.tagName.toLowerCase();
	do {id = prefix + '_' + ('00000' + Math.floor(Math.random() * 1000).toString()).slice(-6)} while(document.getElementById(id));
	if(el) el.id = id;
	return id;
}

/**
 * Namespace for arrays helper functions
 * @namespace EBContext.utils.array
 */
EBContext.utils.array = EBContext.utils.array || {};

/**
 * @param {Array} arr1 First array to merge
 * @param {Array} arr2 Second array to merge
 * @returns {Array} Returns new Array with all source arrays merged into it without duplicates
 */
EBContext.utils.array.merge = function () {
	var i, j;
	var retArr = [];
	for (i = 0; i < arguments.length; i++) {
		if (!Array.isArray(arguments[i])) console.error('Argument ' + typeof arguments[i] + ' is not an Array!');
		for (j = 0; j < arguments[i].length; j++) {
			if (retArr.includes(arguments[i][j])) continue;
			retArr.push(arguments[i][j]);
		}
	}
	return retArr;
};

/**
 * Function to sort array of plain JS objects by values of objects common property
 * @param {Object[]} arr Array of plain JS objects
 * @param {string} key Name of object's property to sort objects by
 * @param {boolean} [desc=false] Switch of sort direction (ascending/descending)
 * @returns {Object[]} Returns array of objects sorted by chosen property's values
 */
EBContext.utils.array.sortObjects = function (arr, key, desc, skipAO) {
	if (desc === undefined) desc = false;
	if (skipAO === undefined) skipAO = false;
	return arr.sort(function (a, b) {
		var x = desc ? b[key] : a[key];
		var y = desc ? a[key] : b[key];
		if (skipAO) {
			x = x.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
			y = y.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
		}
		return ((x < y) ? -1 : ((x > y) ? 1 : 0));
	});
};
//@ALIAS @DEPRICIATED
EBContext.utils.sortObjArray = EBContext.utils.array.sortObjects;

/**
 * @param {Array.<Object>} arr
 * @param {string|number} key
 * @param {*} val
 * @returns {Array.<Object>}
 */
EBContext.utils.array.filterObjects = function (arr, key, val) {
	var retArr = [];
	for (var i = 0; i < arr.length; i++) {
		if (typeof arr[i] == 'object' && arr[i].hasOwnProperty(key)) {
			if ((Array.isArray(arr[i][key]) && arr[i][key].indexOf(val) >= 0) || arr[i][key] === val) {
				retArr.push(arr[i]);
			}
		}
	}
	return retArr;
};

EBContext.utils.array.findLastIndexOf = function(arr, condFn){
	let i;
	for(i=arr.length-1;i>-1;i--) if(condFn(arr[i])) return i;
	return undefined;
};

EBContext.utils.array.findLast = function(arr, condFn){
	return arr[EBContext.utils.array.findLastIndexOf(arr,condFn)];
};

/** creating EBContext.currentPage default structure while preserving the already set page OID */
EBContext.currentPage = EBContext.utils.extendObj(true, {OID: null, blocksData: {}, pageData: {}, eventListeners: []}, EBContext.currentPage);

// DEPRICIATED - Wherewer is used, should be rewritten to use 'EBContext.utils.xmlhttp'!
var TmyWAC = function () {
	var pVersion = '1.0.0';
	var self = this;

	this.version = function () {
		return pVersion;
	};
	this.setSession = function (name, value) {
		console.warning('You are using function that is soon to be depreceated! If you see this message, request refactoring \'myWAC.setSession\' into \'EBContext.session.set\'!');
		var rnd = new Date().getTime() + Math.random();
		var response = self.httpPostRequest('/myWAC/System/Lib/Server/httpsession.asp?rnd=' + rnd + '&session=save&sessionName=' + escape(name), 'sessionValue=' + escape(value).replace(/\+/g, '%2B'), false);
		if (!response) {
			return false;
		}
		return true;
	};
	this.getSession = function (name) {
		console.warning('You are using function that is soon to be depreceated! If you see this message, request refactoring \'myWAC.getSession\' into \'EBContext.session.get\'!');
		var rnd = new Date().getTime() + Math.random();
		var response = self.httpRequest('/myWAC/System/Lib/Server/httpsession.asp?rnd=' + rnd + '&session=get&sessionName=' + escape(name), false);
		if (!response) {
			return false;
		}
		return response;
	};
	this.httpPostRequest = function (url, data, asyn, ctype, callback, errCallback) {
		console.warning('You are using function that is soon to be depreceated! Rewrite any call of \'myWAC.httpPostRequest\' to \'EBContext.utils.xmlHttp\' - see in-code documentation');
		asyn = true;
		var xmlHttp;
		if (window.XMLHttpRequest) {
			xmlHttp = new XMLHttpRequest();
		} else if (window.ActiveXObject) {
			xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
		} else {
			alert(EBContext.resource('USR_browserWithoutXMLHTTP'));
			return;
		}
		xmlHttp.open("POST", url, asyn);
		if (ctype == null) {
			ctype = 'application/x-www-form-urlencoded';
		}
		xmlHttp.setRequestHeader("Content-type", ctype);
		xmlHttp.addEventListener('readystatechange', function () {
			if (xmlHttp.readyState == 4) {
				if (xmlHttp.status != 200) {
					if (asyn && typeof errCallback == 'function') {
						errCallback(xmlHttp.responseText, xmlHttp.status);
					}
					return false;
				} else {
					if (asyn && callback != null) {
						callback(xmlHttp.responseText, asyn);
					}
				}
			} else if (xmlHttp.readyState == 2) {
				if (xmlHttp.status > 399) {
					errCallback(xmlHttp.responseText, xmlHttp.status);
				}
			}
		});

		var postInterface = EBContext.utils.getObj('myWAC.interface.setPostData');
		if (!EBContext.options.ignoreInterface && postInterface) {
			postInterface(data.replace(/\+/g, '%2B'), undefined, undefined, undefined, function () {
				if (xmlHttp) xmlHttp.send(null);
			});
		} else {
			xmlHttp.send(data.replace(/\+/g, '%2B'));
		}
	};

	this.httpRequest = function (url, asyn, callback, xml, object, callbackTimeout, intervalTimeout, errCallback) {
		console.warning('You are using function that is soon to be depreceated! Rewrite any call of \'myWAC.httpRequest\' to \'EBContext.utils.xmlHttp\' - see in-code documentation');
		if (asyn == null) {
			asyn = false;
		}
		if (xml == null) {
			xml = false;
		}
		var xmlHttp;
		if (window.XMLHttpRequest) {
			xmlHttp = new XMLHttpRequest();
		} else if (window.ActiveXObject) {
			xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
		} else {
			alert(EBContext.resource('USR_browserWithoutXMLHTTP'));
			return;
		}
		xmlHttp.open("GET", url, asyn);
		if (callbackTimeout != null) {
			if (intervalTimeout == null) {
				intervalTimeout = 10000;
			}
			xmlHttp.timeout = intervalTimeout;
			xmlHttp.addEventListener('timeout', callbackTimeout);
		}
		xmlHttp.addEventListener('readystatechange', function () {
			var status;
			if (xmlHttp.readyState == 4) {
				try {
					status = xmlHttp.status;
				} catch (x) {
					status = 500;
				}
				if (status > 399) {
					errCallback(xmlHttp.responseText, status);
				} else if (asyn) {
					callback((xml ? xmlHttp.responseXML : xmlHttp.responseText), status);
				}
			} else if (false && xmlHttp.readyState == 2) {
				if (status > 399) {
					errCallback(xmlHttp.responseText, status);
				}
			}
		});
		xmlHttp.addEventListener('error', function (e) {
			errCallback(xmlHttp.responseText, e.type);
		});
		xmlHttp.send();
		if (!asyn) {
			try {
				return (xml ? xmlHttp.responseXML : xmlHttp.responseText);
			} catch (x) {
				return '';
			}
		}
	};
	return this;
};
var myWAC = new TmyWAC();